import React from 'react'
import { mount } from 'enzyme'
import PageLinks from '../features/dashboard/PageLinks'

describe('<PageLinks />', () => {
  const noop = () => {}
  let wrapper, props
  beforeEach(() => {
    props = {
      currentPage: 1,
      totalPages: 2,
      changePage: noop,
      next: noop,
      last: noop,
      first: noop,
      prev: noop
    }
  })
  describe('when the current page is 1 and there is more than one page', () => {
    beforeEach(() => {
      wrapper = mount(<PageLinks {...props} />)
    })
    it('should only render next and last links', () => {
      const navButtons = wrapper.find('PageLinks__NavButton')
      expect(navButtons).toHaveLength(2)
      expect(navButtons.at(0).text()).toContain('Next')
      expect(navButtons.at(1).text()).toContain('Last')
    })
  })
  describe('when there is only one page', () => {
    beforeEach(() => {
      props = {
        ...props,
        totalPages: 1
      }
      wrapper = mount(<PageLinks {...props} />)
    })
    it('should not render any navigation links', () => {
      expect(wrapper.find('PageLinks__NavButton')).toHaveLength(0)
    })
  })
  describe('when the current page is the final page', () => {
    beforeEach(() => {
      props = {
        ...props,
        totalPages: 2,
        currentPage: 2
      }
      wrapper = mount(<PageLinks {...props} />)
    })
    it('should only render first and previous links', () => {
      const navButtons = wrapper.find('PageLinks__NavButton')
      expect(navButtons).toHaveLength(2)
      expect(navButtons.at(0).text()).toContain('First')
      expect(navButtons.at(1).text()).toContain('Prev')
    })
  })
})
